module.exports = __webpack_public_path__ + "static/media/kraken-sushi-bar-identidade-visual.b9b67ae7.jpg";